<template lang="pug">
  //.textfield-box
  b-form-select(
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    :options="options"
    :lazy-formatter="lazyFormatter"
    :size="size"
    :value="value"
    @change="handleClick"
    :disabled="disabled"
  )
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: function () { return [] }
    },
    size: {
      type: String,
      default: "sm"
    },
    lazyFormatter: {
      type: Boolean,
      default: false
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(evt) {
      this.$emit("input", evt);
    }
  }
};
</script>


